import ThumbIcon from './component'

export default ThumbIcon
